/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";

const AddressDisplay = ({ address }) => {
  const { number, street, suburb, postcode, state } = address;
  return (
    <p>
      {number} {street}, {suburb} {postcode} {state}
    </p>
  );
};
AddressDisplay.propTypes = {
  address: PropTypes.object.isRequired
};

const JobDetail = ({ job }) => {
  const jobItems = job.jobItems.map(jobItem => {
    const { quantity, type, description } = jobItem.item;
    return <li key={jobItem.id}>{`${quantity} (${type}) ${description}`}</li>;
  });

  return (
    <table className="table table-bordered table-striped map-job-detail">
      <tbody>
        <tr>
          <td>Job Name</td>
          <td>{job.customerName}</td>
        </tr>
        <tr>
          <td>Address</td>
          <td>
            <p>{job.stop.location.name}</p>
            {job.stop.location.address ? (
              <AddressDisplay address={job.stop.location.address} />
            ) : (
              ""
            )}
          </td>
        </tr>
        <tr>
          <td>Job Type</td>
          <td>{job.type}</td>
        </tr>
        <tr>
          <td>Items</td>
          <td>
            <ul className="list-unstyled">{jobItems}</ul>
          </td>
        </tr>
      </tbody>
    </table>
  );
};
JobDetail.propTypes = {
  job: PropTypes.object.isRequired
};

export default JobDetail;



// WEBPACK FOOTER //
// ./src/components/jobs/MapJobDetail.js